import React from 'react'
import './modal.style.css';



const Modal = (props) => {

    return (
        <>
            < div className="modal-expand modal-wrap" >
                <div className="modal-card">
                    {props.modalComponent}
                </div>

                <div className="modal-expand modal-bg" onClick={props.closeModal}>
                </div>

            </div >
        </>
    )
}

const ModalMenu = (props) => {

    return (
        <>
            < div className={`modal-menu-wrap ${props.type}`} >
                <div className="modal-card">
                    {props.modalComponent}
                </div>

                <div className="modal-menu-bg" onClick={props.closeModal}>
                </div>

            </div >
        </>
    )
}


export {Modal, ModalMenu};

